import { initializeApp } from 'firebase/app';
import {getAuth} from 'firebase/auth';


const firebaseConfig = {
    apiKey: "AIzaSyBiwLlzreV-7GJAtesyiHRqHk0Ta3W41ao",
    authDomain: "nebula-f489e.firebaseapp.com",
    projectId: "nebula-f489e",
    storageBucket: "nebula-f489e.appspot.com",
    messagingSenderId: "279411985012",
    appId: "1:279411985012:web:85f50825c7f66f9f739f21"
  };
  
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

  export const authentification = getAuth(app);
